function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSecurityOff = function SvgSecurityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.99 6.35-.34 2.6c-.6 4.6-3.19 8.68-7.1 11.19l-1.12.72A.76.76 0 0 1 12 21c-.14 0-.28-.04-.41-.12l-1.14-.74c-3.91-2.51-6.5-6.59-7.1-11.19l-.34-2.6c-.05-.39.21-.76.59-.84 1.7-.34 6.46-1.43 8-2.4.25-.15.55-.15.8 0 1.54.97 6.3 2.06 8 2.4.38.08.64.45.59.84z",
    style: {
      fill: "#fff"
    }
  }));
};

export default SvgSecurityOff;